import styled from "styled-components";

import { UserLevelContainer } from "pages/[tenant]/g/components/Feed/components/UserLevel/styles";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";
import { GamificationModalUserPhotoContainer } from "shared/components/molecules/Gamification/GamificationModal/atoms/UserPhoto/styles";
import { NotificationContainerWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer/styles";
import { NotificationFooterContainerContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterContainer/styles";

export const LevelUpNotificationContainer = styled.div`
  position: relative;
  overflow: hidden;

  > canvas {
    inset: initial !important;
    right: -25px !important;
    top: 0 !important;
    max-width: 150px;
    opacity: 0.5;

    @media (max-width: 1366px) {
      right: -45px !important;
    }
  }

  ${NotificationContainerWrapper} {
    background: linear-gradient(
      90deg,
      rgba(255, 204, 77, 0.12) 0%,
      rgba(95, 73, 19, 0.12) 100%
    );
    border-left: 2px solid #ffcb4c;

    grid-template-columns: auto 1fr auto;
  }

  p b {
    color: ${({ theme }) => theme.notification.highlightText} !important;
  }

  .level-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    overflow: hidden;

    ${GamificationModalUserPhotoContainer} {
      margin-bottom: 0;
      z-index: 3;

      @media (max-width: 1366px) {
        .user-info {
          gap: 7px !important;
        }
      }

      ${SimpleUserInitialsNameContainer}, img {
        width: 56px !important;
        height: 56px !important;

        @media (max-width: 1366px) {
          width: 40px !important;
          height: 40px !important;

          h1 {
            font-size: 1rem;
          }
        }
      }

      .circular-progress {
        width: 67px !important;
        height: 67px !important;

        @media (max-width: 1366px) {
          width: 50px !important;
          height: 50px !important;
        }
      }

      .right-starts-icon,
      .left-starts-icon {
        width: 15px;
        height: 15px;
      }
    }

    ${UserLevelContainer} {
      z-index: 3;
    }
  }

  ${NotificationFooterContainerContainer} {
    margin-top: 12px;
  }
`;
